export default __webpack_public_path__ + "static/media/action-edit-icon.da057ddc.svg";